import LocalDateFilter from 'edge/platform/time/LocalDateFilter';
import 'gw-portals-viewmodel-angular';
import JSInteropAscpect from './_JSInteropAspect';

export default angular.module('edge.platform.time', ['gw-portals-viewmodel-angular'])
    .filter('gwLocalDate', LocalDateFilter)
    .run(['ViewModelService', (ViewModelService) => {
        ViewModelService.addAspectFactory(JSInteropAscpect);
    }]);
